import ApiService from "../../../shared/services/ApiService";

export default {

    getLocationAddress(point, memberId) {
        return ApiService.get(`location-address/${point}?memberId=${memberId}`);
    }
}